import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './activity.reducer';

export const ActivityDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const activityEntity = useAppSelector(state => state.activity.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="activityDetailsHeading">
          <Translate contentKey="cabmanApp.activity.detail.title">Activity</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{activityEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="cabmanApp.activity.status">Status</Translate>
            </span>
          </dt>
          <dd>{activityEntity.status}</dd>
          <dt>
            <span id="type">
              <Translate contentKey="cabmanApp.activity.type">Type</Translate>
            </span>
          </dt>
          <dd>{activityEntity.type}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="cabmanApp.activity.name">Name</Translate>
            </span>
          </dt>
          <dd>{activityEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="cabmanApp.activity.description">Description</Translate>
            </span>
          </dt>
          <dd>{activityEntity.description}</dd>
          <dt>
            <span id="startDateTime">
              <Translate contentKey="cabmanApp.activity.startDateTime">Start Date Time</Translate>
            </span>
          </dt>
          <dd>
            {activityEntity.startDateTime ? <TextFormat value={activityEntity.startDateTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="endDateTime">
              <Translate contentKey="cabmanApp.activity.endDateTime">End Date Time</Translate>
            </span>
          </dt>
          <dd>
            {activityEntity.endDateTime ? <TextFormat value={activityEntity.endDateTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <Translate contentKey="cabmanApp.activity.session">Session</Translate>
          </dt>
          <dd>{activityEntity.session ? activityEntity.session.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/activity" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/activity/${activityEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ActivityDetail;
